import rowConfig from './rowConfig';

const getConfig = ({ columnsProps }) => ({
  className: 'perpetuity-growth-terminal-table',
  rowConfig: rowConfig(columnsProps),
});

export default getConfig;
